import { switchMap, mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { INotificationApiDependencySegment } from '@cbridge-packages/api-notifications';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { AlertTranslator } from '@cbridge-packages/alert';
import { AlertSubscriptionAction } from '../alertSubscription.action';

type IDependencies = INotificationApiDependencySegment;

export const loadSubscriptionsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(AlertSubscriptionAction.loadSubscriptions.started),
  switchMap(() => {
    return dependencies.nsApi.getSubscriptions().pipe(
      mergeMap((response) => {
        const result = {
          subscriptions: response.subscriptions.map(AlertTranslator.fromApiSubscription),
          emails: response.emails.filter(Boolean),
        };
        return [
          AlertSubscriptionAction.loadSubscriptions.done({ result }),
        ];
      }),
      catchApiError((error) => {
        return [
          AlertSubscriptionAction.loadSubscriptions.failed({ error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
